var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnknown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 19,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8398 22.1953C17.8555 21.2656 17.9609 20.5312 18.1562 19.9922C18.3516 19.4531 18.75 18.8555 19.3516 18.1992L20.8867 16.6172C21.543 15.875 21.8711 15.0781 21.8711 14.2266C21.8711 13.4062 21.6562 12.7656 21.2266 12.3047C20.7969 11.8359 20.1719 11.6016 19.3516 11.6016C18.5547 11.6016 17.9141 11.8125 17.4297 12.2344C16.9453 12.6562 16.7031 13.2227 16.7031 13.9336H14.5352C14.5508 12.668 15 11.6484 15.8828 10.875C16.7734 10.0938 17.9297 9.70312 19.3516 9.70312C20.8281 9.70312 21.9766 10.1016 22.7969 10.8984C23.625 11.6875 24.0391 12.7734 24.0391 14.1562C24.0391 15.5234 23.4062 16.8711 22.1406 18.1992L20.8633 19.4648C20.293 20.0977 20.0078 21.0078 20.0078 22.1953H17.8398ZM17.7461 25.9102C17.7461 25.5586 17.8516 25.2656 18.0625 25.0312C18.2812 24.7891 18.6016 24.668 19.0234 24.668C19.4453 24.668 19.7656 24.7891 19.9844 25.0312C20.2031 25.2656 20.3125 25.5586 20.3125 25.9102C20.3125 26.2617 20.2031 26.5547 19.9844 26.7891C19.7656 27.0156 19.4453 27.1289 19.0234 27.1289C18.6016 27.1289 18.2812 27.0156 18.0625 26.7891C17.8516 26.5547 17.7461 26.2617 17.7461 25.9102Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/unknown.5f11d21fb39949d53441821010d2183e.svg";
export { ForwardRef as ReactComponent };